import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { User, UserStatusEnum, UserTypeEnum } from './model/user';
import { ApiServiceBase } from 'app/lib/api-service-base.service';
import { AppModule } from 'app/app.module';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class UserService extends ApiServiceBase  implements OnInit, OnDestroy {
	get UserStatusEnum() { return UserStatusEnum; }
	get UserTypeEnum() { return UserTypeEnum; }
	departmentList: any[];

	constructor() {
		super('user');
		this.departmentList = [
			{ id: 'satis', name: 'SATIŞ' },
			{ id: 'depo', name: 'DEPO' },
			{ id: 'sevkiyat', name: 'SEVKİYAT' },
		]
	}
	ngOnInit() { }
	ngOnDestroy(): void { }

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
		// resolve();
		// Promise.all([this.getDataTableRows()]).then(() => {
		// 	resolve();
		// }, reject);
	}
	// get allUsersCache() { return UserService._allUsersCache; }

	private _processItem(user: User): User { return new User(user); }

	private _processItems(items: User[]): User[] {
		let response: User[] = [...items?.map(i => this._processItem(i))];
		return response;

		// let response: User[] = [...items?.map(i => this._processItem(i))];
		// if (this.lib.getUserRightClass(this.entityPrivilage?.entity, 'read') === 'branch')
		// 	response = response.filter(i => i.branchId === this.lib.theUser.branchId);
		// // response = Lib.sort(response, 'name');
		// return response;
	}

	get items$() { return this.lib.http.get<User[]>(`${this.api}`).pipe(map(response => this._processItems(response))); }
	checkTakenByEmail(email: string) { return this.lib.http.get<boolean>(`${this.api}/CheckTakenByEmail/${email}`); }
	checkTakenByUserName(email: string) { return this.lib.http.get<boolean>(`${this.api}/CheckTakenByUserName/${email}`); }
	getItems(statusFilter?: UserStatusEnum) {
		if (statusFilter)
			return this.lib.http.get<User[]>(`${this.api}`).pipe(map(response => this._processItems(response.filter(i => i.status === statusFilter))))
		else return this.lib.http.get<User[]>(`${this.api}`).pipe(map(response => this._processItems(response)));
	}

	getItem(id: number) { return this.lib.http.get<User>(`${this.api}/${id}`).pipe(map(response => this._processItem(response))); }

	post(model: User, method: string = '') {
		return new Observable(observer => {
			model.email = model.email?.toLowerCase().trim();
			if (model.type && typeof model.type === "string") model.type = Number(model.type);

			return this.lib.http.post(`${this.api}${method}`, model).pipe(map(res => this._processItem(res as User)))
				.subscribe((res: User) => {
					observer.next(res);
					observer.complete();
				}, err => {
					console.log('error data', model);
					observer.error(err);
				});
		});
	}
	setUserLang(lang) { return this.lib.http.get(`${this.api}/setUserLang/${lang}`); }
	setUserTheme(theme) { return this.lib.http.get(`${this.api}/setUserTheme/${theme}`); }
	createUser(model: User) { return this.post(model, '/createUser'); }

	// AUTHENTICATION
	login(email: string, password: string) {
		return this.lib.http.post<any>(`${environment.apiUrl}/auth/token`, { email, password }).pipe(map(user => {
			if (user && user.token) {
				// console.log('THE USER', user);
				user.token = user.token;
				this.setCurrentUser(user);
			}
			return user;
		}));
	}

	register(model: User) {
		return new Promise((resolve, reject) => {
			this.lib.http.post<any>(`${environment.apiUrl}/auth/register`, model).subscribe((res: User) => {
				this.login(res.email, model.newUserPassword).subscribe(loginResponse => { resolve(loginResponse) }, reject);
			}, reject);
		});
	}

	registerCompanyAccount(model: User) {
		return new Promise((resolve, reject) => {
			this.lib.http.post<any>(`${environment.apiUrl}/auth/registerCompanyAccount`, model).subscribe((res: User) => {
				this.login(res.email, model.newUserPassword).subscribe(loginResponse => { resolve(loginResponse) }, reject);
			}, reject);
		});
	}

	setCurrentUser(user) {
		// sessionStorage.setItem('theUser', JSON.stringify(user));
		localStorage.setItem('theUser', JSON.stringify(user));
		this.lib.theUser = user;
		AppModule.theUserSubject.next(user);
	}

	canCreate() { return true; }
	canRead(form) { return true; }
	canDelete(form) { return true; }
	canUpdate(form) { return true; }

}
